import Vue from 'vue';
const axios = require('axios');

window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.post-feed__posts')) {
    new Vue({
      el: document.querySelector('.post-feed__posts'),

      data: {
        allPostsLoaded: false,
        posts: [],    
        loading: false
      },
      methods: {
        async getMorePosts (load = 6) {
          const params = { offset: this.posts.length, per_page: load };
          this.loading = true;
          const { data } = await axios.get('/wp-json/wp/v2/posts', { params });
          this.posts = this.posts.concat(data);
          this.allPostsLoaded = data.length < load;
          this.offset += data.length;
          this.loading = false;
        },
        loadMore () {
          if (!this.loading && !this.allPostsLoaded) return this.getMorePosts();
        }
      },
      mounted () {
        this.getMorePosts();
      }
    });
  }
});

// document.addEventListener('click', e => {
// //   if (e.target.matches('.post-feed__load-more')) {
// //     e.target.closest('.post-feed').classList.toggle('post-feed--show-three');
// //   }
// // });

// import axios from 'axios';

// window.addEventListener('DOMContentLoaded', () => {
//   const loadMoreButton = document.getElementsByClassName('post-feed__load-more')[0];

//   loadMoreButton.addEventListener('click', e => {
//     e.preventDefault();
    
//     const offset = 0;

//     /* eslint-disable-next-line */
//     const url = `${wp.ajaxurl}?action=get_post_items_json&offset=${offset}`; 

//     /* eslint-disable-next-line */
//     (`${wp.ajaxurl}`)

//     /* eslint-disable-next-line */
//     axios.get(wp.ajaxurl).then((resp) => {
//       console.log(resp);
//       //   if (resp.data) {
//       //     if (resp.data.length) {
//       //       appendPosts(resp.data, newsFeedContainer);
//       //     }
  
//     //     if (resp.data.length < 6) {
//     //       loadMoreBlogsButton.remove();
//     //     }
//     //   }
//     }).catch((err) => console.log(err));
//   });
// });

// // window.addEventListener('DOMContentLoaded', () => {
// //   const newsFeedBlocks = document.querySelectorAll('.news-feed');
// //   let excludePost = false;

// //   if (document.querySelector('.header-07')) {
// //     excludePost = document.querySelector('.header-07').getAttribute('data-post-id');
// //   }

// //   newsFeedBlocks.forEach((block) => {
// //     const loadMoreBlogsButton = block.querySelector('.load-more__button');
// //     const newsFeedContainer = block.querySelector('.news-feed__articles');
// //     console.log('Loading more');

// //     loadMoreBlogsButton.addEventListener('click', () => {
// //       const offset = block.querySelectorAll('.news-article').length;
// //       /* eslint-disable-next-line */
// //       let url = `${wp.ajaxurl}?action=get_post_items_json&offset=${offset}` 

// //       if (excludePost) {
// //         url = url + `&exclude=${excludePost}`;
// //       }

// //       axios.get(url).then((resp) => {
// //         if (resp.data) {
// //           if (resp.data.length) {
// //             appendPosts(resp.data, newsFeedContainer);
// //           }
  
// //           if (resp.data.length < 6) {
// //             loadMoreBlogsButton.remove();
// //           }
// //         }
// //       }).catch((err) => console.log(err));
// //     });
// //   });

// //   function appendPosts (posts, container) {
// //     const postMarkup = posts.map(post => {
// //       return `
// //       <article class="news-article">
// //         <header class="news-article__header">
// //           <div class="news-article__category">${post.category || ''}</div>
// //           <a href="${post.url}">
// //             <img src="${post.image}" alt="${post.tile}" />
// //           </a>
// //         </header>
// //         <footer class="news-article__details">
// //           <a href="${post.url}">
// //             <div class="news-article__date">${post.date || ''}</div>
// //             <h3>${post.title}</h3>
// //           </a>
// //           <a href="${post.url}" class="news-article__button">Read More</a>
// //         </footer>
// //       </article>
// //       `;
// //     });

// //     container.innerHTML += postMarkup.join('');
// //   }
// // });
